module.exports = __webpack_public_path__ + "img/BLANCO_Acompaniamiento.47641c66.png";